var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn', _vm.classes, { disabled: _vm.disabled }],on:{"click":function($event){$event.preventDefault();!_vm.disabled ? _vm.$emit('clicked') : false}}},[(_vm.icon)?_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }